import {
    GETEVENTSFORM_FETCH_DATA_SUCCESS,
    GETEVENTFORM_HAVE_ERROR,
    GETEVENTSFORM_ARE_LOADING,
  } from "../actionType";
  import HttpService from "../../utils/httpService";
  import { Get } from "../../services/api.service";
  
  // Action creator function to handle different types of getEventForm actions
  export function getEventFormAction(action, payload) {
    switch (action) {
      case GETEVENTFORM_HAVE_ERROR:
        return {
          type: action,
          hasError: payload,
        };
  
      case GETEVENTSFORM_ARE_LOADING:
        return {
          type: action,
          isLoading: payload,
        };
  
      case GETEVENTSFORM_FETCH_DATA_SUCCESS:
        return {
          type: action,
          event: payload,
        };
  
      default:
        return;
    }
  }
  
  // Async action creator function to fetch event form data
  export function getEventFormFetchData(eventId) {
    return async (dispatch) => {
      try {
        // Dispatch action indicating data is loading
        dispatch(getEventFormAction(GETEVENTSFORM_ARE_LOADING, true));
  
        // Make the API call
        const response = await Get(`${HttpService.geteventform}${eventId}`);
        
        if (response) {
          // Dispatch success action with the data
          dispatch(getEventFormAction(GETEVENTSFORM_FETCH_DATA_SUCCESS, response));
          // console.log("response", response);
          return response;
        } else {
          throw new Error('No data received from API');
        }
      } catch (error) {
        console.error('Error fetching event form:', error);
        // Dispatch error action
        dispatch(getEventFormAction(GETEVENTFORM_HAVE_ERROR, true));
        throw error;
      } finally {
        // Ensure loading state is set to false
        dispatch(getEventFormAction(GETEVENTSFORM_ARE_LOADING, false));
      }
    };
  }
  